import gql from 'graphql-tag';
import { definition } from './card';
import { channelCreate, workspaceSection } from './channel';
import {
  AddressComponent,
  AuditCheckboxComponent,
  AuditTagComponent,
  AuditTextComponent,
  CombinedTagsComponent,
  DateComponent,
  DateRangeComponent,
  EmailComponent,
  EntityBatchComponent,
  FileComponent,
  GeolocationComponent,
  InputButtonComponent,
  NumberComponent,
  PersonComponent,
  ReferencedInComponent,
  RelatedCardComponent,
  RelatedCardLookupComponent,
  ScheduledAutomationComponent,
  SignatureComponent,
  StaticTextComponent,
  SubformComponent,
  TagComponent,
  TextComponent,
  TimeTrackerComponent,
  TodoComponent,
  UrlComponent,
} from './component';

export const WorkflowTemplate = gql`
  fragment WorkflowTemplate on WorkflowTemplate {
    id
    businessId
    createdAt
    updatedAt
    userId
    name
    parentId
    requiresName
    isSubform
    channelDefaultConfiguration {
      imageUrl
    }
    behavior {
      onNewCard {
        selectors {
          viewTemplateId
          selector
        }
      }
      onOpenCard {
        selectors {
          viewTemplateId
          selector
        }
      }
    }
    components {
      ...AddressComponent
      ...AuditCheckboxComponent
      ...AuditTagComponent
      ...AuditTextComponent
      ...CombinedTagsComponent
      ...DateComponent
      ...DateRangeComponent
      ...EmailComponent
      ...EntityBatchComponent
      ...FileComponent
      ...GeolocationComponent
      ...NumberComponent
      ...PersonComponent
      ...RelatedCardComponent
      ...RelatedCardLookupComponent
      ...ScheduledAutomationComponent
      ...SignatureComponent
      ...StaticTextComponent
      ...SubformComponent
      ...TagComponent
      ...TextComponent
      ...TodoComponent
      ...InputButtonComponent
      ...TimeTrackerComponent
      ...ReferencedInComponent
      ...UrlComponent
    }
    archivedComponents {
      ...AddressComponent
      ...AuditCheckboxComponent
      ...AuditTagComponent
      ...AuditTextComponent
      ...CombinedTagsComponent
      ...DateComponent
      ...DateRangeComponent
      ...EmailComponent
      ...EntityBatchComponent
      ...FileComponent
      ...GeolocationComponent
      ...NumberComponent
      ...PersonComponent
      ...RelatedCardComponent
      ...RelatedCardLookupComponent
      ...ScheduledAutomationComponent
      ...SignatureComponent
      ...StaticTextComponent
      ...SubformComponent
      ...TagComponent
      ...TextComponent
      ...TodoComponent
      ...InputButtonComponent
      ...TimeTrackerComponent
      ...ReferencedInComponent
      ...UrlComponent
    }
  }
  ${AddressComponent}
  ${AuditCheckboxComponent}
  ${AuditTagComponent}
  ${AuditTextComponent}
  ${CombinedTagsComponent}
  ${DateComponent}
  ${DateRangeComponent}
  ${EmailComponent}
  ${EntityBatchComponent}
  ${FileComponent}
  ${GeolocationComponent}
  ${NumberComponent}
  ${PersonComponent}
  ${RelatedCardComponent}
  ${RelatedCardLookupComponent}
  ${ScheduledAutomationComponent}
  ${SignatureComponent}
  ${StaticTextComponent}
  ${SubformComponent}
  ${TagComponent}
  ${TextComponent}
  ${TodoComponent}
  ${InputButtonComponent}
  ${TimeTrackerComponent}
  ${ReferencedInComponent}
  ${UrlComponent}
`;

export const WorkflowTemplateWithCardDefinition = gql`
  fragment WorkflowTemplateWithCardDefinition on WorkflowTemplate {
    ...WorkflowTemplate
    cardDefinition {
      ...CardDefinition
    }
  }
  ${definition}
  ${WorkflowTemplate}
`;

export const WorkflowEntity = gql`
  fragment WorkflowEntity on WorkflowEntity {
    id
    workflowTemplateId
    createdAt
    updatedAt
    fields
    threadId
    channelId
  }
`;

export const WorkflowApp = gql`
  fragment WorkflowApp on WorkflowApp {
    workflowListItemId
    workspaces {
      ...ChannelCreate
    }
    workspaceSection {
      ...WorkspaceSection
    }
  }

  ${channelCreate}
  ${workspaceSection}
`;
